import { useQuery } from '@tanstack/react-query';

import { FileModel } from 'models';

import { useApiClient } from 'features/api';

export const useFormSubmissionsQuery = (files: FileModel[]) => {
  const apiClient = useApiClient();
  const fileIds = files.map((f) => f.id);

  const {
    data: formSubmissions,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['formSubmissions', fileIds.sort()], // Sort IDs to ensure stable query key
    queryFn: () => {
      if (fileIds.length === 0) {
        return Promise.resolve([]);
      }
      return apiClient.dynamicFormsClient.GetFormSubmissions('File', fileIds);
    },
    enabled: fileIds.length > 0,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return { formSubmissions, isLoading, isError };
};
